import { Component } from '@angular/core';
import { RestAPIService } from 'src/app/services/restapi.service';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.css']
})
export class UnauhorizedComponent {
  constructor(public _restAPI: RestAPIService){
    this._restAPI.loading  = false;
  }
}